import ApplicationBridgeComponent from "./application_bridge_component"

/* This bridge component is used to perform vibrations on the device.
 * When connected, it will patch `navigator.vibrate` to perform vibrations via the bridge component.
 */

export default class extends ApplicationBridgeComponent {
  static component = "vibration"

  connect () {
    super.connect()
    this.install()
  }

  disconnect () {
    super.disconnect()
    this.uninstall()
  }

  install () {
    this.previousVibrate = navigator.vibrate
    navigator.vibrate = this.navigatorVibrateWithBridgeComponent
  }

  uninstall () {
    navigator.vibrate = this.previousVibrate
  }

  navigatorVibrateWithBridgeComponent = (pattern) => {
    this.send("vibrate", { pattern })
  }

  vibrate ({ params: { pattern = 50 } }) {
    this.send("vibrate", { pattern })
  }
}
